import { Button, Flex } from '@chakra-ui/react';
import { useState } from 'react';

import Dialog from '@app/components/common/modals/dialog';
import { AutocompleteField, Txt } from '@app/components/common';
import { useAutocomplete } from '@app/hooks';
import { Transaction } from '@app/api/models/transaction';

import { ActionDialogProps } from './types';

export const ConfirmManagerDialog = ({ onAction, selectedTx, isPackage, actionName }: ActionDialogProps) => {
  const [open, setOpen] = useState(false);

  const [distributor, setDistributor] = useState<EntityBase>(isPackage 
    ? (selectedTx.items[0] as Transaction).distr : (selectedTx as Transaction).distributor);
  const getAutocomplete = useAutocomplete();

  const onSubmit = () => {
    if (isPackage) {return;}
    onAction(distributor ? { ...selectedTx, distributor } : selectedTx);
    setOpen(false);
  };

  return <>
    <Button colorScheme='green' onClick={() => setOpen(true)} >{actionName}</Button>
    <Dialog
      open={open}
      title="Соогласовать транзакцию"
      onClose={() => setOpen(false)}
      actions={[
        <Button variant='solid' colorScheme='green' key='cancel' onClick={onSubmit}>Подтвердить</Button>
      ]}
    >
      <Flex flexDirection='column' gap={4}>
        <Txt>Подтвердить перемещение ХО?</Txt>
        <AutocompleteField 
          id='distributor'
          name='distributor'
          label='Дистрибьютор'
          value={distributor}
          onChange={setDistributor}
          onFetchOptions={getAutocomplete}
        />
      </Flex>
    </Dialog>
  </>;
};